import React, { useEffect, useRef } from 'react'
import * as reviewerCommentType from './reviewerCommentType'

import arrayMutators from 'final-form-arrays'
import MyAccordion from '../../../../../control/accordion/accordion'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../i18n/useTranslate'
import ResultConsideration from '../../../shareUI/resultConsideration/resultConsideration'
import CommentDirector from '../../../shareUI/commentDirector/commentDirector'
import Autocomplete from '../../../../../control/autocomplete/autocomplete'
import useReviewerComment from './useReviewerComment'
import Dialog from '../../../../../control/dialog/dialog'
import PageAction from '../pageAction'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import Button from '../../../../../control/button/button'

import { Form, FormSpy } from 'react-final-form'
import { Box, Grid, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import CopyToclipboard from '../../../../../control/copyToClipboard/copyToclipboard'
import ButtonSubmittedWithdraw from '../_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'
import useChecklistStore from '../../../../../stores/checklist/useChecklistStore'
import ExportToMSWord from '../../../../../control/exportToMSWord/exportToMSWord'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../../utilities/date'
import useCommentaryStore from '../../../../../stores/commentary/useCommentaryStore'
import { ChecklistTopic } from '../../../../../services/web/useChecklist'
import authenStore from '../../../../../stores/authen/authenStore'
import useExampleInfomation from '../../../../../hooks/useExampleInfomation'

const ReviewerCommentREC2View: React.FC<reviewerCommentType.ReviewerCommentViewType> = (props) => {
    const {
        role,
        formRef,
        director,
        isViewMode,
        isCommittee,
        isDeadlineOfGeneralCommittee,
        configDialog,
        initialValues,
        documentTopic,
        initialComment,
        commentTitleList,
        initialUploadFile,
        isDisplayCopyToClipboard,
        dataSourceForCopyToClipboard,
        projectData,
        showSaveDraft,
        submitTypeID,
        dataSourceForExport,
        dataForShowUpdateDate,
        onSubmitForm,
        onClickCancel,
        onDirtyChange,
        onChangStatus,
        onRefDialogTwo,
        onChangeDirector,
        onClickBackToSearch,
        onAutoSave,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()
    const classes = useStyles()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const { hasExampleInfomation, downloadExampleInfomation } = useExampleInfomation()

    const irb = projectData?.irb
    const { checklist } = useChecklistStore()
    const { selectedCommitteeID } = useCommentaryStore()
    const profileStore = authenStore()
    const form = formRef.current?.getState().values
    const isOtherCommittee = isCommittee && Number(form?.director?.value) !== Number(profileStore?.profile.userId)

    const isDisable = initialValues?.isDisableFrm || isViewMode || isDeadlineOfGeneralCommittee
    const shouldShowChecklistWarning = !isViewMode && Array.isArray(initialComment) && initialComment.length > 1

    function isChecklistValid(): boolean {
        return (checklist as ChecklistTopic[]).every((topic) =>
            topic.data.every((checklist) => {
                const isChecklistAnswerValid =
                    !checklist.answers || checklist.answers.length === 0
                        ? true
                        : checklist.answers.some((a) => a.checked)

                const isSubChecklistAnswerValid =
                    checklist.children?.every((subChecklist) => {
                        return !subChecklist.answers || subChecklist.answers.length === 0
                            ? true
                            : subChecklist.answers.some((a) => a.checked)
                    }) ?? true

                return isChecklistAnswerValid && isSubChecklistAnswerValid
            }),
        )
    }

    const renderMainReviewer = (change: <F extends string | number | symbol>(name: F, value?: any) => void) => {
        return (
            <React.Fragment>
                <Grid item xs={12} md={6} lg={6} className={classes.grid}>
                    <Autocomplete
                        name="director"
                        materialInputProps={{
                            label: translate.get('LABEL.COMMITTEE_NAME'),
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                        }}
                        options={director}
                        onChangeValue={(val) => {
                            onChangeDirector(val, change)
                        }}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} className={classes.grid}>
                    <Autocomplete
                        name="role"
                        materialInputProps={{
                            label: translate.get('LABEL.ROLE'),
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                            disabled: true,
                        }}
                        options={role}
                        required
                    />
                </Grid>
            </React.Fragment>
        )
    }

    const autoSaveTimer = useRef<any>(null)
    const lastAutoSaveTime = useRef<number>(0)
    const mountTime = useRef(Date.now())

    const triggerDraftSubmit = (values?: any) => {
        const latestValues = formRef.current?.getState?.()?.values ?? values
        if (!latestValues) return

        onAutoSave({ ...latestValues, submitType: 'draft', autoSave: true })
    }

    // ---------- autosave ----------
    // เดิม setInterval 5 นาที ไม่ได้เช็ค lastAutoSaveTime เลย ยิงซ้อนกับ debounce 1 นาทีได้ รวมให้เหลือทางเข้าเดียวคือ runAutoSave ต้องระวังยิงซ้อน
    const runAutoSave = (values: any) => {
        if (!values) return

        const now = Date.now()
        // ไม่ autosave ใน 1 นาทีแรกหลังเปิดหน้า
        if (now - mountTime.current < 60 * 1000) return
        // เว้นระยะอย่างน้อย 1 นาทีจากรอบที่แล้ว
        if (now - lastAutoSaveTime.current < 60 * 1000) return

        lastAutoSaveTime.current = now
        triggerDraftSubmit(values)
    }

    useEffect(() => {
        mountTime.current = Date.now()
        lastAutoSaveTime.current = 0

        return () => {
            if (autoSaveTimer.current) {
                clearTimeout(autoSaveTimer.current)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAutoSave = (values: any, isDirty: boolean) => {
        if (!isDirty) return

        if (autoSaveTimer.current) {
            clearTimeout(autoSaveTimer.current)
        }

        autoSaveTimer.current = setTimeout(() => {
            const latestValues = formRef.current?.getState?.()?.values ?? values
            runAutoSave(latestValues)
        }, 60 * 1000)
    }

    return (
        <>
            {isDisplayCopyToClipboard || hasExampleInfomation ? (
                <Grid container item spacing={2} xs={12} justify={'flex-end'} className={classes.btnExport}>
                    {isDisplayCopyToClipboard ? (
                        <>
                            <ExportToMSWord dataSource={dataSourceForExport} irb={Number(irb)} />
                            <CopyToclipboard dataSource={dataSourceForCopyToClipboard} pageType={'1'} />
                        </>
                    ) : null}

                    {hasExampleInfomation ? (
                        <Box style={{ padding: 10 }}>
                            <Button
                                style={{ backgroundColor: '#0062FF', color: 'white' }}
                                onClick={downloadExampleInfomation}
                            >
                                {translate.get('BUTTON.EXPORT_EXAMPLE_INFOMATION')}
                            </Button>
                        </Box>
                    ) : null}
                </Grid>
            ) : null}
            <Form
                onSubmit={onSubmitForm}
                initialValues={{ ...initialValues, commentDirector: initialComment, uploadFile: initialUploadFile }}
                mutators={{
                    ...arrayMutators,
                }}
                keepDirtyOnReinitialize={true}
            >
                {(props) => {
                    const { form, handleSubmit, dirty, invalid, errors } = props
                    formRef.current = form
                    return (
                        <React.Fragment>
                            <Grid container spacing={2} justify="flex-end">
                                <Grid item xs={12} md={12} lg={12}>
                                    <MyAccordion title={translate.get('LABEL.REVIEWER_COMMENT')}>
                                        <Grid container spacing={2}>
                                            {renderMainReviewer(form.change)}
                                        </Grid>
                                    </MyAccordion>
                                </Grid>

                                {shouldShowChecklistWarning && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Box className={classes.warningBox}>โปรดทำเช็คลิสต์ ก่อนกรอกข้อมูลความคิดเห็นลงในระบบ</Box>
                                    </Grid>
                                )}

                                <Grid item xs={12} md={12} lg={12} xl={12}>
                                    <CommentDirector
                                        commentTitleList={commentTitleList}
                                        disabled={isDisable}
                                        committeeID={selectedCommitteeID?.toString()}
                                        initialcomment={initialComment}
                                        isViewMode={isViewMode}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={12} xl={12}>
                                    <UploadDoc
                                        documentTitleList={documentTopic}
                                        initialData={initialUploadFile}
                                        isViewMode={isDisable}
                                    />
                                </Grid>

                                <Grid item xs={12} md={12} lg={12}>
                                    <ResultConsideration
                                        irb={irb}
                                        submitTypeID={submitTypeID}
                                        disabled={isDisable}
                                        onChangStatus={onChangStatus}
                                    />
                                </Grid>

                                {initialValues.isShowUpdateDate && (
                                    <Grid container item xs={12} justify="flex-end">
                                        {translate.get('LABEL.UPDATER')} :
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? dataForShowUpdateDate?.nameTH
                                            : dataForShowUpdateDate?.nameEN}
                                        &nbsp;&nbsp;
                                        {translate.get('LABEL.UPDATE_DATE')} :
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? convertDateToFormatTH(dataForShowUpdateDate?.date ?? '')
                                            : convertDateToFormatEN(dataForShowUpdateDate?.date ?? '')}
                                    </Grid>
                                )}

                                {!isDisable && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <PageAction
                                            onClickClose={() => {
                                                onClickCancel(dirty)
                                            }}
                                            onClickSave={() => {
                                                form.change('submitType', 'save')
                                                handleSubmit()
                                                // if (
                                                //     (commentTitleList.length > 1 && isChecklistValid()) ||
                                                //     commentTitleList.length === 1
                                                // ) {
                                                //     handleSubmit()
                                                // }

                                                // invalid &&
                                                //     errors &&
                                                //     snackbarAction.openSnackbar({
                                                //         message: translate.get('MESSAGE.M012'),
                                                //         type: 'error',
                                                //     })

                                                // if (commentTitleList.length > 1 && !isChecklistValid()) {
                                                //     snackbarAction.openSnackbar({
                                                //         message: translate.get('MESSAGE.M027'),
                                                //         type: 'error',
                                                //     })
                                                // }
                                            }}
                                            onClickSaveDraft={
                                                showSaveDraft
                                                    ? () => {
                                                          form.change('submitType', 'draft')
                                                          handleSubmit()
                                                      }
                                                    : undefined
                                            }
                                        />
                                    </Grid>
                                )}

                                {isDisable && !isViewMode && (
                                    <Grid container item justify="space-between" spacing={2}>
                                        <Grid item xs={12} sm={'auto'}>
                                            <ButtonSubmittedWithdraw
                                                gridProps={{ xs: true }}
                                                fullWidth={isMobileView ? true : false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={'auto'}>
                                            <Button
                                                color="primary"
                                                onClick={onClickBackToSearch}
                                                fullWidth={isMobileView ? true : false}
                                            >
                                                {translate.get('BUTTON.CLOSE')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                            <Dialog onRef={onRefDialogTwo} {...configDialog} />
                            <FormSpy
                                subscription={{ values: true, dirty: true }}
                                onChange={(state) => {
                                    onDirtyChange(state)
                                    handleAutoSave(state.values, !!state.dirty)
                                }}
                            />
                        </React.Fragment>
                    )
                }}
            </Form>
        </>
    )
}

const ReviewerCommentREC2: React.FC<reviewerCommentType.ReviewerCommentType> = (props) => {
    const useReviewerCommentModel = useReviewerComment(props)
    return <ReviewerCommentREC2View {...useReviewerCommentModel} {...props} />
}

const useStyles = makeStyles(() => ({
    grid: {
        marginBottom: '0px',
    },
    btnExport: {
        padding: '18px',
    },
    warningBox: {
        border: '1px solid #ffcdd2',
        borderLeft: '4px solid #d32f2f',
        borderRadius: '4px',
        backgroundColor: '#ffebee',
        color: '#b71c1c',
        fontWeight: 700,
        padding: '10px 12px',
    },
}))

export default ReviewerCommentREC2
